import * as React from 'react'

import * as styles from './index.vanilla.css'

interface Props {
  d: string | null
}

const Link: React.FC<Props> = ({ d }) => {
  if (!d) return null

  return <path className={styles.link} d={d} />
}

export default Link
